export const CashierBetStateEnum = {
  Postponed: -100,
  Edited: -99,
  Rollbacked: -3,
  Rejected: -1,
  NotResulted: 0,
  Accepted: 1,
  Returned: 2,
  Lost: 3,
  Won: 4,
  CashOut: 5,
};

export const CashierBetStateViewEnum = {
  [CashierBetStateEnum.Postponed]: 'Postponed',
  [CashierBetStateEnum.Edited]: 'Edited',
  [CashierBetStateEnum.Rollbacked]: 'Rollbacked',
  [CashierBetStateEnum.Rejected]: 'Rejected',
  [CashierBetStateEnum.NotResulted]: 'Pending',
  [CashierBetStateEnum.Accepted]: 'Pending',
  [CashierBetStateEnum.Returned]: 'Returned',
  [CashierBetStateEnum.Lost]: 'Lost',
  [CashierBetStateEnum.Won]: 'Won',
  [CashierBetStateEnum.CashOut]: 'Cash-outed',
};
